module.exports = __webpack_public_path__ + "img/eclipse.75b1710d.svg";